import React, { memo } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Remote } from '@okapi/remote';
import { Layout } from 'fronton-react';

const remoteCarouselLayout = css`
  @media (width <= 375px) {
    padding: 0;
  }
`;

const plpCarousel = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 56px;
    overflow: hidden;
  }
`;

export const remoteCarousel = css`
  div {
    font-family: Roboto, apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans',
      'Helvetica Neue', sans-serif !important;
  }

  @media (--only-desktop) {
    width: 100%;
  }
`;

type RemoteCarouselProps = {
  className?: string;
  elementBlock: string;
  title: string;
  productIdList: string[];
  remoteId?: string;
  seeMoreLink?: string;
  showSeeMore?: boolean;
};

/**
 * Ремоуте компонент карусели со списком товаров и ремоутом с логикой работы корзины
 */
export const RemoteCarouselWithBasket: React.FC<RemoteCarouselProps> = memo(
  ({ className, title, elementBlock, productIdList, remoteId, seeMoreLink = '', showSeeMore = false }) => (
    <Layout className={remoteCarouselLayout}>
      <section className={cn(plpCarousel, className)}>
        <Remote widget="basket-logic/basket-logic" id="basket-logic" />
        <Remote
          className={remoteCarousel}
          widget="product-carousel/root"
          data={{
            title,
            seeMoreLink,
            showSeeMore,
            productsIds: productIdList,
            elementBlock,
          }}
          id={remoteId || elementBlock}
        />
      </section>
    </Layout>
  )
);
